import React, { forwardRef } from 'react';

import { BookOpenText } from 'lucide-react';
import { AdminIcon } from 'src/components/icons/AdminIcon';
import { AIChatIcon } from 'src/components/icons/AIChatIcon';
import { AlineLogoIconPlain } from 'src/components/icons/AlineLogoIconPlain';
import { BellIcon } from 'src/components/icons/BellIcon';
import { CommunityIcon } from 'src/components/icons/CommunityIcon';
import { DashboardIcon } from 'src/components/icons/DashboardIcon';
import { DocumentIcon } from 'src/components/icons/DocumentIcon';
import { GroupIcon } from 'src/components/icons/GroupIcon';
import { IconColors } from 'src/components/icons/icon-utils';
import { ReportsIcon } from 'src/components/icons/ReportsIcon';
import { TagsIcon } from 'src/components/icons/TagsIcon';
import { TemplateIcon } from 'src/components/icons/TemplateIcon';
import { WorkflowNavIcon } from 'src/components/icons/WorkflowNavIcon';
import { themeV5 } from 'src/theme';

import type { AppSection } from '../ui-interfaces';
import { LeftNavSection } from '../ui-interfaces';

interface LeftNavIconProps {
  section: AppSection;
  selected: boolean;
}

export const LeftNavIcon = forwardRef(function LeftNavIcon(
  { section, selected, ...rest }: LeftNavIconProps,
  ref: React.Ref<SVGSVGElement>
): JSX.Element {
  const fill = themeV5.palette.common.white;

  // Note: need to spread {...rest} for AlineTooltip to work as a parent component since MUI Tooltip injects props into child...
  switch (section) {
    case LeftNavSection.ADMIN:
      return <AdminIcon ref={ref} fill={fill} {...rest} />;
    case LeftNavSection.AI_CHAT:
      return <AIChatIcon fill={fill} />;
    case LeftNavSection.DASHBOARD:
      return <DashboardIcon ref={ref} fill={fill} {...rest} />;
    case LeftNavSection.IDENTIFIERS:
      return <TagsIcon ref={ref} fill={fill} {...rest} />;
    case LeftNavSection.PARTIES:
      return <GroupIcon ref={ref} fill={fill} {...rest} />;
    case LeftNavSection.PLAYBOOKS:
      return <BookOpenText ref={ref} color={fill} size={24} strokeWidth={1.5} {...rest} />;
    case LeftNavSection.REMINDERS:
      return <BellIcon fill={fill} />;
    case LeftNavSection.GET_STARTED:
      return <AlineLogoIconPlain ref={ref} fill={IconColors.White} {...rest} />;
    case LeftNavSection.REPORTS:
      return <ReportsIcon ref={ref} fill={fill} {...rest} />;
    case LeftNavSection.REPOSITORY:
      return <DocumentIcon ref={ref} fill={fill} {...rest} />;
    case LeftNavSection.WORKFLOWS:
      return <WorkflowNavIcon fill={fill} />;
    case LeftNavSection.TEMPLATES:
      return <TemplateIcon fill={fill} {...rest} />;
    case LeftNavSection.COMMUNITY:
      return <CommunityIcon ref={ref} fill={fill} {...rest} />;
  }
});
